import { Container } from 'inversify'

import { RelationSportOptionalIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportOptionalDependencies'

import EventStats from '../LiveView/EventStats.vue'

export function bindEventStatsComponent(ioc: Container): void {
  ioc.bind(RelationSportOptionalIoCBindings.EventStats).toDynamicValue(() => {
    return EventStats
  })
}
